// The server caps each page at 300. Keep the catalog complete in every consumer.
export const fetchCustomerCatalog = async (api, params = {}, isCurrent = () => true) => {
  const records = [];
  let page;
  do {
    const { data } = await api.get('/customers', {params:{...params,limit:300,offset:records.length}});
    if (!isCurrent()) return null;
    page = Array.isArray(data) ? data : [];
    records.push(...page);
  } while (page.length === 300);
  return records;
};
